import { useState } from 'react'

import PageContainer from '@/common/components/PageContainer'
import SlideAnnouncementPreview from '@/modules/client-setting/components/SlideAnnouncementPreview'
import SlideAnnouncementForm from '@/modules/client-setting/components/SlideAnnouncementForm'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function SlideAnnouncementPage() {
	const [previewContent, setPreviewContent] = useState('')

	return (
		<PageContainer>
			<div className="space-y-6">
				<div>
					<h1 className="text-2xl font-bold">จัดการประกาศสไลด์</h1>
					<p className="text-muted-foreground">
						สร้างและแก้ไขประกาศที่จะแสดงบนหน้าเว็บไซต์
					</p>
				</div>

				<div className="grid gap-6 lg:grid-cols-2">
					<div className="order-2 lg:order-1">
						<SlideAnnouncementForm onContentChange={setPreviewContent} />
					</div>

					<div className="order-1 lg:order-2">
						<SlideAnnouncementPreview content={previewContent} />
					</div>
				</div>
			</div>
		</PageContainer>
	)
}

const GuardedSlideAnnouncementPage = withUserPermission(SlideAnnouncementPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedSlideAnnouncementPage
